/**
 * Stable CSS class names for E2E — SummaryAggregation SummaryDetailSearch page.
 */
export const SDS = {
    page: 'sa-summary-detail-search-page',
    root: 'sa-summary-detail-search',

    breadcrumb: 'sa-summary-detail-search__breadcrumb',
    titleIcon: 'sa-summary-detail-search__title-icon',
    loading: 'sa-summary-detail-search__loading',

    list: 'sa-summary-detail-search__list',
    listSearchBar: 'sa-summary-detail-search__list-search-bar',
    listSearchLabel: 'sa-summary-detail-search__list-search-label',
    orderNumberInput: 'sa-summary-detail-search-input--order-number',
    btnSearch: 'sa-summary-detail-search-input--button-search',

    listGridContainer: 'sa-summary-detail-search__list-grid-container',
    listGrid: 'sa-summary-detail-search__list-grid',
    listNoRecord: 'sa-summary-detail-search__list-no-record',
} as const;
